import { css } from "@emotion/css";
import { space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
import React from "react";
import type { DesignSystemLinkHref } from "../../routing";
import { useOctopusLinkComponent } from "../../routing";
import { resetStyles } from "../../utils";
import { Tag, type TagProps } from "./Tag";
export interface TagGroupProps {
    /** Array of tag props to render */
    tags: TagProps[];
    /** Limit the number of visible tags */
    limit?: {
        /** Maximum number of tags to display before showing '+X more' */
        count: number;
        /** Link for the '+X more' text. Should navigate to a page where all tags can be viewed. */
        link: DesignSystemLinkHref;
    };
}
export function TagGroup({ tags, limit }: TagGroupProps) {
    const Link = useOctopusLinkComponent();
    const shouldApplyLimit = limit && limit.count > 0;
    const visibleTags = shouldApplyLimit ? tags.slice(0, limit.count) : tags;
    const moreCount = shouldApplyLimit && tags.length > limit.count ? tags.length - limit.count : 0;
    return (<ul className={styles.root}>
            {visibleTags.map((tag, index) => (<li key={index} className={styles.listItem}>
                    <Tag {...tag}/>
                </li>))}
            {limit && moreCount > 0 && (<li className={styles.listItem}>
                    <Link className={styles.moreText} href={limit.link}>
                        +{moreCount} more
                    </Link>
                </li>)}
        </ul>);
}
const styles = {
    root: css({
        ...resetStyles.list,
        display: "flex",
        flexWrap: "wrap",
        gap: space[8],
    }),
    listItem: css({
        alignContent: "center",
    }),
    moreText: css({
        textDecoration: "none",
        color: themeTokens.color.text.link.default,
        font: text.body.regular.medium,
    }),
};
